// extracted by mini-css-extract-plugin
export default {"layout":"Category_layout__WQKPN","cardLayout":"Category_cardLayout__sc2uA","ankoerTag":"Category_ankoerTag__fniz5","showMore":"Category_showMore__VWjX5","btn":"Category_btn__32EWp"};